import { observable } from 'mobx';

export type ExpensesAccountTypeResponseArgs = {
  id: number;
  code: string;
  name: string;
};

export type ExpensesAccountTypeArgs = {
  id: number;
  code: string;
  name: string;
};

export const convertExpensesAccountTypeResponseToArgs = (response: ExpensesAccountTypeResponseArgs) => {
  const args: ExpensesAccountTypeArgs = {
    id: response.id,
    code: response.code,
    name: response.name
  };
  return args;
};

export default class ExpensesAccountType {
  @observable id: number;
  @observable code: string;
  @observable name: string;

  constructor(args: ExpensesAccountTypeArgs) {
    this.id = args.id;
    this.code = args.code;
    this.name = args.name;
  }

  get codeAndNameOneLine(): string {
    return `${this.code}:${this.name}`;
  }
}
